<template>
  <div class="faq">
    <faq-item v-for="item in data" :item="item" :key="item.id"> </faq-item>
  </div>
</template>

<script>
import FaqItem from "./FaqItem";

export default {
  name: "Faq",
  components: { FaqItem },
  props: {
    data: Array,
  },
};
</script>

<style lang="scss" scoped>
.faq {
  padding: 0;
  margin-top: 1em;
  border-radius: var(--radius-second);
  border: solid 1px #e9e9eb;
}
</style>
